const decode = (value) => {
  try { return value ? decodeURIComponent(value) : null; } catch (_) { return value || null; }
};

const GAMING_VIEWS = new Map([
  ["/gaming", "Overview"],
  ["/gaming/overview", "Overview"],
  ["/gaming/games", "Games"],
  ["/gaming/catalog", "Catalog"],
  ["/gaming/market", "Market"],
  ["/gaming/competitors", "Competitors"],
  ["/gaming/match-review", "Match Review"],
  ["/gaming/data-health", "Data Health"],
]);

/**
 * Maps browser locations to real Nexus surfaces. `invalid` is intentionally
 * explicit so a protected nested URL never silently falls back to Gaming.
 */
export function routeFromLocation(pathname = "/", search = "", { commandCenter = true } = {}) {
  const rawPath = pathname || "/";
  const path = rawPath.replace(/\/+$/, "") || "/";
  const hasTrailingSlash = rawPath.length > 1 && rawPath.endsWith("/");
  if (path === "/" || path === "/home") return { tab: "home", path };
  if (path === "/saudi") return { tab: "home", path };
  if (path === "/saudi/market") return { tab: commandCenter ? "mv_bff" : "macro", path };
  if (path === "/saudi/malls") return { tab: "malls", path };
  if (path === "/saudi/pipeline") return { tab: "pipeline", path };
  if (path === "/saudi/merchant") return { tab: "profiler", path };
  if (path.startsWith("/saudi/merchant/")) {
    const entityId = decode(path.split("/")[3]);
    return entityId ? { tab: "profiler", entityId, path } : { invalid: true, path };
  }
  if (path === "/oman") return { tab: "oman_macro", path };
  if (path === "/oman/market") return { tab: "oman_macro", path };
  if (path === "/oman/malls") return { tab: "oman_malls", path };
  if (path === "/oman/pipeline") return { tab: "oman_pipeline", path };
  if (path.startsWith("/oman/merchant/") || path.startsWith("/oman/branch/")) {
    const entityId = decode(path.split("/")[3]);
    return entityId ? { tab: "oman_profiler", entityId, path } : { invalid: true, path };
  }
  if (GAMING_VIEWS.has(path)) return { tab: "gaming", gamingView: GAMING_VIEWS.get(path), path };
  if (path.startsWith("/gaming/game/")) {
    const gameId = decode(path.split("/")[3]);
    return gameId ? { tab: "gaming", gamingView: "Game Detail", gameId, path } : { invalid: true, path };
  }
  if (path === "/support" || path === "/support/overview") return { tab: "support", path };
  if (path === "/support/intelligence") return { tab: "cs_intelligence", path };
  if (hasTrailingSlash && (path === "/support/agents" || path === "/support/tickets")) {
    return { invalid: true, path, search };
  }
  if (path === "/support/agents") return { tab: "agents", path };
  if (path.startsWith("/support/agents/")) {
    const entityId = decode(path.split("/")[3]);
    return entityId ? { tab: "agentProfile", entityId, path } : { invalid: true, path };
  }
  if (path === "/support/tickets") return { tab: "tickets", path };
  if (path.startsWith("/support/tickets/")) {
    const entityId = decode(path.split("/")[3]);
    return entityId ? { tab: "chat", entityId, path } : { invalid: true, path };
  }
  return { invalid: true, path, search };
}

export function pathForTab(tab, { entityId, gamingView } = {}) {
  if (tab === "home" || tab === "mv_bff") return tab === "mv_bff" ? "/saudi/market" : "/home";
  if (tab === "macro") return "/saudi/market";
  if (tab === "malls") return "/saudi/malls";
  if (tab === "pipeline") return "/saudi/pipeline";
  if (tab === "oman_macro") return "/oman/market";
  if (tab === "oman_malls") return "/oman/malls";
  if (tab === "oman_pipeline") return "/oman/pipeline";
  if (tab === "oman_profiler") return entityId ? `/oman/merchant/${encodeURIComponent(entityId)}` : "/oman/merchant";
  if (tab === "profiler") return entityId ? `/saudi/merchant/${encodeURIComponent(entityId)}` : "/saudi/merchant";
  if (tab === "gaming") {
    if (gamingView === "Game Detail" && entityId) return `/gaming/game/${encodeURIComponent(entityId)}`;
    const view = [...GAMING_VIEWS.entries()].find(([, value]) => value === gamingView)?.[0];
    return view || "/gaming";
  }
  if (tab === "support" || tab === "agents" || tab === "tickets") return `/${tab === "support" ? "support/overview" : `support/${tab}`}`;
  if (tab === "cs_intelligence") return "/support/intelligence";
  if (tab === "chat") return entityId ? `/support/tickets/${encodeURIComponent(entityId)}` : "/support/tickets";
  if (tab === "agentProfile") return entityId ? `/support/agents/${encodeURIComponent(entityId)}` : "/support/agents";
  return `/${String(tab || "home").replace(/^\//, "")}`;
}
